module.exports = __webpack_public_path__ + "static/title-mob-1-ddb0737f7f238776d46e0e7ead04783f.png";